import { DOCUMENT } from "@angular/common";
import {
  Directive,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output
} from "@angular/core";
import { Subscription, fromEvent as observableFromEvent } from "rxjs";
import { filter } from "rxjs/operators";

@Directive({
  selector: "[taClickOut]"
})
export class ClickOutDirective implements OnInit, OnDestroy {
  @Input()
  taClickOutIncludeOverlays: boolean = true;

  @Output()
  taClickOut: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  private documentRef: Document;
  constructor(private elemRef: ElementRef, @Inject(DOCUMENT) documentRef: any) {
    this.documentRef = documentRef;
  }

  private _documentClickSubscription: Subscription;
  ngOnInit(): void {
    let elem = this.elemRef.nativeElement;

    setTimeout(() => {
      this._documentClickSubscription = observableFromEvent(
        this.documentRef,
        "click"
      )
        .pipe(
          filter((event: MouseEvent) => {
            // if click target is within element
            if (elem === event.target || elem.contains(event.target)) {
              return false;
            }

            // if click target is not within element and we don't care to filter overlays
            if (!this.taClickOutIncludeOverlays) {
              return true;
            }

            // if overlay is clicked, don't close
            return !this.isOverlayOrChildOfOverlay(event.target as HTMLElement);
          })
        )
        .subscribe(this.taClickOut.emit.bind(this.taClickOut));
    });
  }

  ngOnDestroy(): void {
    if (this._documentClickSubscription != null) {
      this._documentClickSubscription.unsubscribe();
    }
  }

  private isOverlayOrChildOfOverlay(eventTarget: HTMLElement | null): boolean {
    if (eventTarget == null) {
      return false;
    }

    return (
      eventTarget.classList.contains("overlay") ||
      this.isOverlayOrChildOfOverlay(eventTarget.parentElement)
    );
  }
}
